module.exports = __webpack_public_path__ + "static/img/PK.a769ea04.png";